// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Estils específics de l'editor d'Horari (Empresa i Empleat):
   calendari anual, chips de rangs i franges. Prefix "horari-empresa-".
   El xassís de la pantalla (capçalera, cards, botons) és v2 (dv2-*). */

.horari-empresa-accions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin: 10px 0;
}

.dv2-btn.horari-empresa-btn-petit {
  min-height: 32px;
  padding: 4px 10px;
  font-size: 13px;
}

.horari-empresa-renombrar .dv2-input {
  width: auto;
  min-width: 16rem;
  flex: 1 1;
}

.horari-empresa-periodes {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 16px;
}

.horari-empresa-periode {
  background-color: var(--dv2-surface, #ffffff);
  border: 1px solid var(--dv2-border, #ddd);
  border-radius: var(--dv2-radius, 8px);
  padding: 16px 18px 18px;
  box-shadow: var(--dv2-shadow, none);
}

.horari-empresa-periode-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 10px;
  font-size: 16px;
}

.horari-empresa-nom-periode {
  cursor: pointer;
}

.horari-empresa-nom-periode:hover {
  color: #0078d7;
}

.horari-empresa-renombrar {
  display: flex;
  align-items: center;
  gap: 6px;
}

.horari-empresa-bloc {
  margin-top: 10px;
}

.horari-empresa-bloc-titol {
  font-weight: bold;
  font-size: 13px;
  color: #555;
  margin: 10px 0 6px;
  text-transform: uppercase;
}

.horari-empresa-formulari {
  background-color: #f9f9f9;
  border: 1px dashed #ccc;
  border-radius: 6px;
  padding: 12px;
  margin: 10px 0;
}

.horari-empresa-btn-petit {
  width: auto;
  padding: 6px 12px;
}

.horari-empresa-error {
  color: #d9534f;
  font-weight: bold;
}

.horari-empresa-avis {
  color: #d9534f;
  font-size: 12px;
}

.horari-empresa-tancat {
  color: #999;
  font-style: italic;
  font-size: 13px;
}

.horari-empresa-link-canviar {
  background: none;
  border: none;
  color: #0078d7;
  text-decoration: underline;
  cursor: pointer;
  font-size: 13px;
  padding: 0;
}

/* Rangs de dates com a "chips" */
.horari-empresa-rangs-chips {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.horari-empresa-rang-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background-color: #eef5fc;
  border: 1px solid #bcdcf5;
  border-radius: 16px;
  padding: 4px 10px;
  font-size: 13px;
}

.horari-empresa-rang-chip button {
  background: none;
  border: none;
  cursor: pointer;
  color: #555;
  font-size: 13px;
  padding: 0;
}

.horari-empresa-rang-chip button:hover {
  color: #0078d7;
}

/* Editor de franges: seleccionar dies + hora, i llista de resultat per dia */
.horari-empresa-editor-franges {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 6px;
}

.horari-empresa-afegir-franja {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  background-color: #f5f8fb;
  border: 1px solid #dde7f0;
  border-radius: 6px;
  padding: 8px 10px;
}

.horari-empresa-selector-dies {
  display: flex;
  gap: 4px;
}

.horari-empresa-dia-toggle {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 1px solid #ccc;
  background-color: #ffffff;
  color: #333;
  font-size: 12px;
  font-weight: bold;
  cursor: pointer;
}

.horari-empresa-dia-toggle:hover {
  border-color: #0078d7;
}

.horari-empresa-dia-toggle-actiu {
  background-color: #0078d7;
  border-color: #0078d7;
  color: #ffffff;
}

.horari-empresa-afegir-franja-hores {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.horari-empresa-afegir-franja-hores input[type="time"] {
  padding: 4px 6px;
  font-size: 13px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.horari-empresa-franges-llista {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.horari-empresa-dia-fila {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 6px 0;
  border-bottom: 1px solid #eee;
}

.horari-empresa-dia-nom {
  width: 90px;
  flex-shrink: 0;
  font-weight: bold;
  font-size: 13px;
  padding-top: 2px;
}

.horari-empresa-dia-franges {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.horari-empresa-franja-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background-color: #f1f1f1;
  border-radius: 12px;
  padding: 3px 8px;
  font-size: 13px;
}

.horari-empresa-franja-chip button {
  background: none;
  border: none;
  cursor: pointer;
  color: #999;
  font-size: 12px;
  padding: 0;
}

.horari-empresa-franja-chip button:hover {
  color: #d9534f;
}

.horari-empresa-franges-resum {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 8px;
  font-size: 13px;
}

.horari-empresa-franges-resum-fila strong {
  margin-right: 4px;
}

/* Calendari estil "aerolínia" per triar data d'inici i data final: mostra
   l'any complet (12 mesos), ja que els períodes solen ser amplis. */
.horari-empresa-calendari {
  background-color: #ffffff;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 12px;
  margin: 10px 0;
}

.horari-empresa-calendari-capcalera {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 12px;
}

.horari-empresa-calendari-any {
  font-size: 20px;
  font-weight: bold;
  min-width: 60px;
  text-align: center;
}

.horari-empresa-calendari-mesos {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 16px;
}

.horari-empresa-calendari-mes {
  border: 1px solid #eee;
  border-radius: 6px;
  padding: 8px;
}

.horari-empresa-calendari-mes-titol {
  font-weight: bold;
  text-align: center;
  margin-bottom: 6px;
  font-size: 13px;
}

.horari-empresa-calendari-dies-setmana,
.horari-empresa-calendari-graella {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 2px;
}

.horari-empresa-calendari-dia-setmana {
  font-size: 11px;
  font-weight: bold;
  text-align: center;
  color: #777;
}

.horari-empresa-calendari-dia {
  font-size: 12px;
  text-align: center;
  padding: 4px 0;
  border-radius: 4px;
  cursor: pointer;
}

.horari-empresa-calendari-dia:hover {
  background-color: #e0e0e0;
}

.horari-empresa-calendari-dia-buit {
  cursor: default;
}

.horari-empresa-calendari-dia-buit:hover {
  background-color: transparent;
}

.horari-empresa-calendari-dia-rang {
  background-color: #d6ecff;
}

.horari-empresa-calendari-dia-extrem {
  background-color: #0078d7;
  color: #ffffff;
  font-weight: bold;
}

.horari-empresa-calendari-dia-extrem:hover {
  background-color: #005a9e;
}

.horari-empresa-calendari-resum {
  text-align: center;
  font-size: 13px;
  margin: 12px 0;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/horariempresa.css"],"names":[],"mappings":"AAAA;;uEAEuE;;AAEvE;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,6CAA6C;EAC7C,yCAAyC;EACzC,qCAAqC;EACrC,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,eAAe;EACf,UAAU;AACZ;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA,6EAA6E;AAC7E;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;oEACoE;AACpE;EACE,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB","sourcesContent":["/* Estils específics de l'editor d'Horari (Empresa i Empleat):\n   calendari anual, chips de rangs i franges. Prefix \"horari-empresa-\".\n   El xassís de la pantalla (capçalera, cards, botons) és v2 (dv2-*). */\n\n.horari-empresa-accions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  margin: 10px 0;\n}\n\n.dv2-btn.horari-empresa-btn-petit {\n  min-height: 32px;\n  padding: 4px 10px;\n  font-size: 13px;\n}\n\n.horari-empresa-renombrar .dv2-input {\n  width: auto;\n  min-width: 16rem;\n  flex: 1;\n}\n\n.horari-empresa-periodes {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-top: 16px;\n}\n\n.horari-empresa-periode {\n  background-color: var(--dv2-surface, #ffffff);\n  border: 1px solid var(--dv2-border, #ddd);\n  border-radius: var(--dv2-radius, 8px);\n  padding: 16px 18px 18px;\n  box-shadow: var(--dv2-shadow, none);\n}\n\n.horari-empresa-periode-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin-bottom: 10px;\n  font-size: 16px;\n}\n\n.horari-empresa-nom-periode {\n  cursor: pointer;\n}\n\n.horari-empresa-nom-periode:hover {\n  color: #0078d7;\n}\n\n.horari-empresa-renombrar {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.horari-empresa-bloc {\n  margin-top: 10px;\n}\n\n.horari-empresa-bloc-titol {\n  font-weight: bold;\n  font-size: 13px;\n  color: #555;\n  margin: 10px 0 6px;\n  text-transform: uppercase;\n}\n\n.horari-empresa-formulari {\n  background-color: #f9f9f9;\n  border: 1px dashed #ccc;\n  border-radius: 6px;\n  padding: 12px;\n  margin: 10px 0;\n}\n\n.horari-empresa-btn-petit {\n  width: auto;\n  padding: 6px 12px;\n}\n\n.horari-empresa-error {\n  color: #d9534f;\n  font-weight: bold;\n}\n\n.horari-empresa-avis {\n  color: #d9534f;\n  font-size: 12px;\n}\n\n.horari-empresa-tancat {\n  color: #999;\n  font-style: italic;\n  font-size: 13px;\n}\n\n.horari-empresa-link-canviar {\n  background: none;\n  border: none;\n  color: #0078d7;\n  text-decoration: underline;\n  cursor: pointer;\n  font-size: 13px;\n  padding: 0;\n}\n\n/* Rangs de dates com a \"chips\" */\n.horari-empresa-rangs-chips {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n}\n\n.horari-empresa-rang-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background-color: #eef5fc;\n  border: 1px solid #bcdcf5;\n  border-radius: 16px;\n  padding: 4px 10px;\n  font-size: 13px;\n}\n\n.horari-empresa-rang-chip button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #555;\n  font-size: 13px;\n  padding: 0;\n}\n\n.horari-empresa-rang-chip button:hover {\n  color: #0078d7;\n}\n\n/* Editor de franges: seleccionar dies + hora, i llista de resultat per dia */\n.horari-empresa-editor-franges {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-top: 6px;\n}\n\n.horari-empresa-afegir-franja {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px;\n  background-color: #f5f8fb;\n  border: 1px solid #dde7f0;\n  border-radius: 6px;\n  padding: 8px 10px;\n}\n\n.horari-empresa-selector-dies {\n  display: flex;\n  gap: 4px;\n}\n\n.horari-empresa-dia-toggle {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  border: 1px solid #ccc;\n  background-color: #ffffff;\n  color: #333;\n  font-size: 12px;\n  font-weight: bold;\n  cursor: pointer;\n}\n\n.horari-empresa-dia-toggle:hover {\n  border-color: #0078d7;\n}\n\n.horari-empresa-dia-toggle-actiu {\n  background-color: #0078d7;\n  border-color: #0078d7;\n  color: #ffffff;\n}\n\n.horari-empresa-afegir-franja-hores {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.horari-empresa-afegir-franja-hores input[type=\"time\"] {\n  padding: 4px 6px;\n  font-size: 13px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.horari-empresa-franges-llista {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.horari-empresa-dia-fila {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 6px 0;\n  border-bottom: 1px solid #eee;\n}\n\n.horari-empresa-dia-nom {\n  width: 90px;\n  flex-shrink: 0;\n  font-weight: bold;\n  font-size: 13px;\n  padding-top: 2px;\n}\n\n.horari-empresa-dia-franges {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n}\n\n.horari-empresa-franja-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background-color: #f1f1f1;\n  border-radius: 12px;\n  padding: 3px 8px;\n  font-size: 13px;\n}\n\n.horari-empresa-franja-chip button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #999;\n  font-size: 12px;\n  padding: 0;\n}\n\n.horari-empresa-franja-chip button:hover {\n  color: #d9534f;\n}\n\n.horari-empresa-franges-resum {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-bottom: 8px;\n  font-size: 13px;\n}\n\n.horari-empresa-franges-resum-fila strong {\n  margin-right: 4px;\n}\n\n/* Calendari estil \"aerolínia\" per triar data d'inici i data final: mostra\n   l'any complet (12 mesos), ja que els períodes solen ser amplis. */\n.horari-empresa-calendari {\n  background-color: #ffffff;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  padding: 12px;\n  margin: 10px 0;\n}\n\n.horari-empresa-calendari-capcalera {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.horari-empresa-calendari-any {\n  font-size: 20px;\n  font-weight: bold;\n  min-width: 60px;\n  text-align: center;\n}\n\n.horari-empresa-calendari-mesos {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  gap: 16px;\n}\n\n.horari-empresa-calendari-mes {\n  border: 1px solid #eee;\n  border-radius: 6px;\n  padding: 8px;\n}\n\n.horari-empresa-calendari-mes-titol {\n  font-weight: bold;\n  text-align: center;\n  margin-bottom: 6px;\n  font-size: 13px;\n}\n\n.horari-empresa-calendari-dies-setmana,\n.horari-empresa-calendari-graella {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 2px;\n}\n\n.horari-empresa-calendari-dia-setmana {\n  font-size: 11px;\n  font-weight: bold;\n  text-align: center;\n  color: #777;\n}\n\n.horari-empresa-calendari-dia {\n  font-size: 12px;\n  text-align: center;\n  padding: 4px 0;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.horari-empresa-calendari-dia:hover {\n  background-color: #e0e0e0;\n}\n\n.horari-empresa-calendari-dia-buit {\n  cursor: default;\n}\n\n.horari-empresa-calendari-dia-buit:hover {\n  background-color: transparent;\n}\n\n.horari-empresa-calendari-dia-rang {\n  background-color: #d6ecff;\n}\n\n.horari-empresa-calendari-dia-extrem {\n  background-color: #0078d7;\n  color: #ffffff;\n  font-weight: bold;\n}\n\n.horari-empresa-calendari-dia-extrem:hover {\n  background-color: #005a9e;\n}\n\n.horari-empresa-calendari-resum {\n  text-align: center;\n  font-size: 13px;\n  margin: 12px 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
